module.exports = __webpack_public_path__ + "img/Huawei-P20-Pro1.f04f0a7b.png";